import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updatePresetName } from '@api/kpi';

import { IEditPresetNameFncDTO } from '@interfaces/kpi/dto/kpiDTO';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { PRESET_OPTIONS, UPDATE_PRESET_NAME } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdatePresetName = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleUpdatePresetName,
		isLoading: isLoadingUpdatePresetName,
	} = useMutation<IEditPresetNameFncDTO>({
		mutationKey: [UPDATE_PRESET_NAME],
		allowedRoles: [EUserRoles.networkOperatorKpiUpdater, EUserRoles.networkOperatorKpiViewer],
		mutationFn: async ({ data, closePresetForm, setPresetValue, isPresetValue }: IEditPresetNameFncDTO) => {
			await updatePresetName(data);
			closePresetForm();

			if (isPresetValue) {
				setPresetValue(prevState => ({
					...prevState,
					name: data.name,
					label: data.name,
				}));
			}

			dispatch(setSnackbar({
				message: responseMessages.renamePreset(data.name),
				type: ESnackbarTypes.success,
			}));
		},
		onSuccess: () => {
			return queryClient.invalidateQueries([PRESET_OPTIONS]);
		},
	});

	return {
		handleUpdatePresetName,
		isLoadingUpdatePresetName,
	};
};
